import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface EditRaumData {
  id: string;
  name: string;
  sektionId: string;
}

@Component({
  selector: 'app-edit-raum-dialog',
  templateUrl: './edit-raum-dialog.component.html',
  styleUrls: ['./edit-raum-dialog.component.css'],
})
export class EditRaumDialogComponent implements OnInit {
  frmRaum: UntypedFormGroup;
  raumId: string;
  sektionId: string;

  constructor(
    public dialogRef: MatDialogRef<EditRaumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRaumData,
    private _fb: UntypedFormBuilder
  ) {
    this.raumId = data.id;
    this.sektionId = data.sektionId;

    this.frmRaum = this._fb.group({
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      sektion_id: [this.sektionId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmRaum.valid) {
      this.dialogRef.close({ 
        event: 'update', 
        data: {
          id: this.raumId,
          ...this.frmRaum.value
        }
      });
    }
  }

  onDelete(): void {
    const confirmed = confirm('Sind Sie sicher, dass Sie diesen Raum deaktivieren möchten? Er wird als inaktiv markiert und in der Historie angezeigt.');
    if (confirmed) {
      this.dialogRef.close({ 
        event: 'delete', 
        data: { 
          id: this.raumId,
          name: this.frmRaum.get('name')?.value || this.data.name
        }
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}

